import React, { useRef, useState } from "react";

import styled from "styled-components/macro";

import FnrTypography from "FnrTypography";

import FnrIcon from "UI/FnrIcon";

import ButtonTooltip from "./ButtonTooltip";
import useBoardLocation from "./hooks/useBoardLocation";

export default function BoardGroups({
  groups = {},
  hasMultipleGroups = false,
  groupsArray = [],
  createdBy = "",
  isShared = false,
}) {
  const iconRef = useRef();

  const [isHovering, setIsHovering] = useState(false);

  const { isReportBoard } = useBoardLocation();

  if (!groups || groupsArray.length === 0 || !isReportBoard) return null;

  return (
    <>
      <IconWrapper
        ref={iconRef}
        onPointerEnter={() => setIsHovering(true)}
        onPointerLeave={() => setIsHovering(false)}
        onClick={() => setIsHovering((hovering) => !hovering)}
      >
        <I className="fas fa-info-circle" />
      </IconWrapper>

      <ButtonTooltip
        show={isHovering}
        buttonRef={iconRef}
        content={
          <>
            <GroupWrapper>
              <h4>Group{hasMultipleGroups ? "s" : ""} in this report</h4>
              {hasMultipleGroups ? (
                <UL>
                  {groupsArray.map((group) => (
                    <li key={group.ID}>{group.name}</li>
                  ))}
                </UL>
              ) : (
                <div>{groupsArray[0].name}</div>
              )}
            </GroupWrapper>

            {(createdBy || isShared) && (
              <InfoWrapper>
                {createdBy && (
                  <InfoItem>
                    <FnrIcon
                      style={{
                        fontSize: "0.6rem",
                        marginRight: "0.25rem",
                      }}
                      fad
                      fa-user
                    />
                    <FnrTypography type="copy" fontSize="xs" color="textLight">
                      Created by {createdBy}
                    </FnrTypography>
                  </InfoItem>
                )}
                {isShared && (
                  <InfoItem>
                    <FnrIcon
                      style={{
                        fontSize: "0.55rem",
                        marginRight: "0.25rem",
                      }}
                      fad
                      fa-share
                    />
                    <FnrTypography type="copy" fontSize="xs" color="textLight">
                      Shared with other admins
                    </FnrTypography>
                  </InfoItem>
                )}
              </InfoWrapper>
            )}
          </>
        }
      />
    </>
  );
}

const IconWrapper = styled.div`
  display: grid;
  place-items: center;
`;
const I = styled.i`
  font-size: 0.75rem;
`;
const GroupWrapper = styled.div`
  text-align: left;
  padding: 0.25rem 0.5rem;

  h4 {
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
`;
const UL = styled.ul`
  margin-block-start: 0;
  padding-inline-start: 1rem;
`;

const InfoWrapper = styled.div`
  padding: 0.25rem 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 0.5rem;
  border-top: 1px solid #ccc;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

const SFnrIcon = styled(FnrIcon)`
  font-size: 0.25rem;
  width: 0.5rem;
  height: 0.5rem;
`;
